exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://use.typekit.net/srv0wme.css);", ""]);

// module
exports.push([module.id, "/*\r\n$breakpoint argument choices:\r\n- xs\r\n- sm\r\n- md\r\n- lg\r\n- xl\r\n*/\n.cardProfileFollow[data-v-068a8aa6] {\n  padding-top: 25px;\n}\n.cardProfileFollow .copy[data-v-068a8aa6] {\n    text-align: center;\n    font-size: 24px;\n    cursor: pointer;\n    color: #585e5e;\n}\n.cardProfileFollow .copy[data-v-068a8aa6]:hover {\n      color: #304048;\n}\n.cardProfileFollow .copy.disable[data-v-068a8aa6] {\n      pointer-events: none;\n}\n", ""]);

// exports
